import { createSelector, createSlice, PayloadAction } from 'redux-starter-kit';
import { selectAppState } from '../../../App/state/selectors';
import { ShiftRecordSections, ShiftInfoSection } from '../types';

export interface ShiftRecordState {
  error?: string;
  isLoadingInfo: boolean;
  infoSection?: ShiftInfoSection;
  sections?: ShiftRecordSections;
}

const initialState: ShiftRecordState = {
  isLoadingInfo: false,
};

const ShiftRecordSlice = createSlice({
  slice: 'shiftRecord',
  initialState: initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchShiftRecord(state, { payload }: PayloadAction<number>) {
      state.isLoadingInfo = true;
      state.error = undefined;
    },
    fetchShiftRecordSuccess(
      state,
      {
        payload: { sections },
      }: PayloadAction<{
        sections: ShiftRecordSections;
      }>,
    ) {
      state.isLoadingInfo = false;
      state.infoSection = sections;
      state.sections = sections;
    },
    fetchShiftRecordFail(state, { payload }: PayloadAction<string>) {
      state.isLoadingInfo = false;
      state.error = payload;
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getShiftRecord },
} = ShiftRecordSlice;

export const selectors = {
  selectRequestShiftState: createSelector([selectAppState], getShiftRecord),
};

export const {
  fetchShiftRecord,
  fetchShiftRecordSuccess,
  fetchShiftRecordFail,
} = actions;

export default reducer;
